<template>
  <div>
    <app-header title="Templates">
      <b-button
        v-router-link="{ name: 'template-editor', params: { id: 'new' } }"
        variant="primary"
      >
        <i class="fa fa-plus-circle" /> New Template </b-button
      >&nbsp;
      <b-button
        v-router-link="{ name: 'template-bulk-import' }"
        variant="primary"
      >
        <i class="fa fa-upload" /> Bulk Import
      </b-button>
    </app-header>
    <b-container class="mt-5">
      <b-row>
        <b-col>
          <search-input v-model="query" />
        </b-col>
        <b-col class="text-right">
          {{ totalRows }} Templates
          <b-button variant="light" @click="download()" class="mr-1">
            Download (all)
          </b-button>
          <b-button variant="light" @click="download(3)">
            Download (3 days)
          </b-button>
        </b-col>
      </b-row>
      <b-table
        id="store-table"
        :per-page="perPage"
        :current-page="currentPage"
        :items="displayTemplates"
        :fields="fields"
        :busy="loading"
        show-empty
        striped
        hover
        responsive
        selectable
        select-mode="single"
        @row-selected="view"
      >
        <template v-slot:cell(updated)="data">
          {{ data.item.updated | moment('YYYY-MM-DD') }}
        </template>
        <template v-slot:cell(created)="data">
          {{ data.item.created | moment('YYYY-MM-DD') }}
        </template>
        <template v-slot:table-busy>
          <loading-spinner />
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="displayTemplates && displayTemplates.length"
        :per-page="perPage"
        align="right"
        aria-controls="subdistributor-table"
      />
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import $csv from '@/services/csv';
import $search from '@/services/search';
import LoadingSpinner from '@/components/LoadingSpinner';
import SearchInput from '@/components/SearchInput';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
    LoadingSpinner,
    SearchInput,
  },

  data() {
    return {
      sortOrder: null,
      fields: [
        { key: 'id', label: 'Template ID' },
        { key: 'manufacturer_name', label: 'Manufacturer Name' },
        { key: 'device_name', label: 'Device Name' },
        { key: 'name', label: 'Template Name' },
        { key: 'hidden', label: 'Hidden', sortable: true },
        { key: 'updated', label: 'Updated', sortable: true },
        { key: 'created', label: 'Created', sortable: true },
        { key: 'hpgl_width', label: 'Width' },
        { key: 'hpgl_height', label: 'Height' },
      ],
      currentPage: 1,
      perPage: 20,
      query: null,
    };
  },

  computed: {
    totalRows() {
      return this.templates && this.templates.length;
    },

    displayTemplates() {
      return $search(this.templates, this.query, [
        'name',
        'device_name',
        'manufacturer_name',
      ]);
    },

    ...mapState('templates', {
      loading: 'loading',
      templates: 'list',
    }),
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      this.$store.dispatch('templates/ensure');
    },

    download(days) {
      let data = this.templates;
      if (days) {
        data = data.filter(
          (item) =>
            new Date(item.updated).getTime() >
            Date.now() - days * 1000 * 60 * 60 * 24,
        );
      }
      $csv.export(
        data,
        [
          'id',
          'manufacturer_name',
          'device_name',
          'name',
          'hidden',
          'updated',
          'created',
          'hpgl_width',
          'hpgl_height',
          'svg',
        ],
        'templatelog.csv',
      );
    },

    view(rows) {
      this.$router.push({ name: 'template-detail', params: rows[0] });
    },
  },
};
</script>
